const configs = {
  release: {
    apiKey: "AIzaSyBYAxtz2DtzbOq5kAJyMQd_quQ1tlauv-I",
    authDomain: "parkin-prod-v1-8fc44.firebaseapp.com",
    databaseURL: "https://parkin-prod-v1-8fc44.firebaseio.com",
    projectId: "parkin-prod-v1-8fc44",
    storageBucket: "parkin-prod-v1-8fc44.appspot.com",
    messagingSenderId: "363206789510",
    appId: "1:363206789510:web:87ac88c7839dc0c7ac0407",
    measurementId: "G-0LQ2N6NZ7L"
  },
  preprod: {
    apiKey: "AIzaSyDV3njCpJ_VqZIiErubX7hK8McBLDxAoXk",
    authDomain: "parkin-preprod-1.firebaseapp.com",
    databaseURL: "https://parkin-preprod-1.firebaseio.com",
    projectId: "parkin-preprod-1",
    storageBucket: "parkin-preprod-1.appspot.com",
    messagingSenderId: "1051857356425",
    appId: "1:1051857356425:web:606e9da4b9d70261e7e858",
    measurementId: "G-8KH6JFQZQ9"
  },
  debug: {
    apiKey: "AIzaSyA3FdGYnttLySBe1f4b8Oui-MXREHywH6w",
    authDomain: "parkin-dev-fb285.firebaseapp.com",
    databaseURL: "https://parkin-dev-fb285.firebaseio.com",
    projectId: "parkin-dev-fb285",
    storageBucket: "parkin-dev-fb285.appspot.com",
    messagingSenderId: "220181666579",
    appId: "1:220181666579:web:9f86f9aada5cebcf"
  },
}

const env = {
  debug: {
    httpURL: 'https://us-central1-parkin-dev-fb285.cloudfunctions.net',
  },
  preprod: {
    httpURL: 'https://us-central1-parkin-preprod-1.cloudfunctions.net/',
  },
  release: {
    httpURL: 'https://us-central1-parkin-prod-v1-8fc44.cloudfunctions.net/',
  },
}

export const firebaseConfig = configs[process.env.REACT_APP_STAGE]
export const config = env[process.env.REACT_APP_STAGE]
